import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-40cb818e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "margin-b-standard" }
const _hoisted_2 = { class: "available-files margin-b-standard" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { "data-testing": "existing-file-name" }
const _hoisted_5 = ["data-testing", "value"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

import { LibraryFile } from "@/models/files.model";
import { SectionFile } from "@/models/product-section.model";
import { computed, onMounted, ref } from "vue";
import { useUIFilesStore } from "@/stores/ui-files.store";
import { useFilesStore } from "@/stores/files.store";
import { useFileManager } from "@/composables/files-manager";
import RightSidebarTitle from "@/components/right-sidebars/ui/RightSidebarTitle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FileLibraryForm',
  setup(__props) {

const filesStore = useFilesStore();
const uiFilesStore = useUIFilesStore();
const { linkFileToProduct, linkFileToSection } = useFileManager();

const existingFileFilter = ref<string>("");
const existingFileId = ref<number | undefined>(undefined);

const isFileInSection = (file: LibraryFile): boolean => {
  if (!uiFilesStore.sectionToAttachFile) {
    return false;
  }
  return uiFilesStore.sectionToAttachFile.enabled_files.some(
    (sectionFile: SectionFile): boolean => {
      return sectionFile.id === file.id;
    }
  );
};
const doesFileNameMatchFilter = (file: LibraryFile): boolean => {
  return file.name
    .toLowerCase()
    .includes(existingFileFilter.value.toLowerCase());
};
const filesData = computed<LibraryFile[]>(() => {
  let files = filesStore.files ?? [];
  files = files.filter((file: LibraryFile) => {
    return !isFileInSection(file);
  });
  files = files.filter(doesFileNameMatchFilter);
  return files;
});

const attachFileToProduct = (attachedFileId: number): void => {
  if (uiFilesStore.productToAttachFile && uiFilesStore.fileAttachmentType) {
    linkFileToProduct({
      product_id: uiFilesStore.productToAttachFile.id,
      attachment_type: uiFilesStore.fileAttachmentType,
      file_id: attachedFileId
    });
  }
};
const attachFileToSection = (attachedFileId: number): void => {
  if (uiFilesStore.sectionToAttachFile) {
    linkFileToSection({
      productId: uiFilesStore.sectionToAttachFile.product_id,
      section_id: uiFilesStore.sectionToAttachFile.id,
      file_id: attachedFileId,
      is_media_content: uiFilesStore.shouldBeSetAsMediaContent
    });
  }
};
const attachExistingFile = (): void => {
  if (existingFileId.value) {
    if (uiFilesStore.sectionToAttachFile) {
      attachFileToSection(existingFileId.value);
    } else {
      attachFileToProduct(existingFileId.value);
    }
  }

  uiFilesStore.closeAttachFileModal();
};

const clearExistingFileSelection = (): void => {
  existingFileId.value = undefined;
};

const existingFileFilterInput = ref<HTMLElement | null>(null);
onMounted(() => {
  if (existingFileFilterInput.value) {
    existingFileFilterInput.value.focus();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(attachExistingFile, ["prevent"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(RightSidebarTitle, { title: 'Search your library of attachments:' }),
      _withDirectives(_createElementVNode("input", {
        onKeyup: clearExistingFileSelection,
        id: "existing-file-filter",
        ref_key: "existingFileFilterInput",
        ref: existingFileFilterInput,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((existingFileFilter).value = $event)),
        "data-testing": "attach-existing-file-name"
      }, null, 544), [
        [_vModelText, existingFileFilter.value]
      ])
    ]),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filesData.value, (file) => {
        return (_openBlock(), _createElementBlock("li", {
          value: file.id,
          key: file.id
        }, [
          _createElementVNode("label", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              "data-testing": `existing-file-name-${file.id}`,
              type: "radio",
              value: file.id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((existingFileId).value = $event))
            }, null, 8, _hoisted_5), [
              [_vModelRadio, existingFileId.value]
            ]),
            _createTextVNode(" " + _toDisplayString(file.name), 1)
          ])
        ], 8, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("button", {
      "data-testing": "attach-existing-file-btn",
      disabled: !existingFileId.value,
      class: "btn-1 full-width submit-btn"
    }, [
      (_unref(uiFilesStore).shouldBeSetAsMediaContent)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Set as Media Content"))
        : (_openBlock(), _createElementBlock("span", _hoisted_8, "Attach content"))
    ], 8, _hoisted_6)
  ], 32))
}
}

})